export default {
  props: { file: Object },
  data() {
    return {
      options: {
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "airplay",
          "fullscreen",
        ],
      },
    };
  },

  watch: {
    file() {
      console.log("update");
    },
  },
};
